import type { HttpInterceptorFn } from '@angular/common/http';

const interceptOnlyApi = (url: string): boolean => url.includes('/api/') && !url.includes('/media/');

const addTrailingSlash = (url: string): string => {
  if (url.endsWith('/') || url.includes('/?')) {
    return url;
  }
  if (url.includes('?')) {
    return url.replace('?', '/?');
  }
  return url + '/';
};

export const trailingSlashesInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url;
  if (interceptOnlyApi(url)) {
    const newUrl = addTrailingSlash(url);
    return next(req.clone({ url: newUrl }));
  }
  return next(req);
};
